var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.154 18c-.191 0-.379-.045-.553-.13a.692.692 0 0 1-.089-.046L10 15.734l-3.514 2.091a1.258 1.258 0 0 1-1.392-.08 1.372 1.372 0 0 1-.5-1.347l.818-4.141-1.37-1.3-1.622-1.54a.663.663 0 0 1-.066-.073 1.383 1.383 0 0 1-.291-1.331 1.306 1.306 0 0 1 1.08-.916l4.021-.465 1.665-3.846a.625.625 0 0 1 .051-.098A1.275 1.275 0 0 1 10 2c.464 0 .893.266 1.12.687.018.032.035.065.051.1l1.667 3.847 4.021.465a1.308 1.308 0 0 1 1.08.918 1.384 1.384 0 0 1-.358 1.403l-2.992 2.841.819 4.133a1.38 1.38 0 0 1-.505 1.355c-.216.163-.476.251-.748.251zm-6.971-5.857c-.034.163-.399 2.004-.723 3.642l3.116-1.853a.824.824 0 0 1 .847 0l3.117 1.852-.726-3.662a.914.914 0 0 1 .263-.84l2.652-2.519-3.566-.411a.86.86 0 0 1-.685-.521L10 4.42l-1.477 3.41a.865.865 0 0 1-.685.521l-3.566.411 2.652 2.518c.233.22.329.55.259.862z",
    fill: "#FCBD38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBorder);
export default __webpack_public_path__ + "static/media/star-border.5581a55acaf1f617371aaf87fe176acb.svg";
export { ForwardRef as ReactComponent };